import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, debounceTime, filter, map, scan, switchMap } from "rxjs";
import { RentVsBuyDbType } from "@home-shark/types";
import { updateRentVsBuy } from "../actions/rent-vs-buy.actions";
import { ApiHttpService } from "../../../../services/api.service";

@Injectable()
export class RentVsBuyEffects {
    public actions$ = inject(Actions);
    public api = inject(ApiHttpService);

    openInfo$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRentVsBuy),
            scan((acc: {} | RentVsBuyDbType, action) => {
                return { ...acc, ...action.state };
            }, {}),
            debounceTime(500),
            switchMap((data) => {
                return this.api
                    .put("/users/componentState/rent-vs-buy", data)
                    .pipe(
                        catchError((err) => {
                            return null;
                        }),
                        map((data) => {
                            return null;
                        })
                    );
            }),
            filter((action) => !!action)
        )
    );
}
